import React, { useState } from "react";
import PropTypes from "prop-types";
import { of, switchMap } from "rxjs";
import PubmedFormWidget from "../PubmedUserEntries/PubmedFormWidget";
import ContributionEl from "./Contribution";
import Contribution from "../../models/Contribution";
import Thread from "./Thread";
import SourceEntity from "../Publications/models/SourceEntity";
import Btn from "../atoms/Btn";
import PubmedEntry from "../PubmedUserEntries/PubmedEntry";
import apiClient from "../../services/apiClient";

function ContributionContainer({
  contribution,
  sourceEntity,
  article,
  shouldShowThread,
}) {
  const [edited, setEdited] = useState(false);
  const slug = sourceEntity.getSlugForContribution(contribution.id);
  const { canEdit } = contribution || {};

  const loadEntry = (id) => {
    of(null)
      .pipe(switchMap(() => apiClient.getClassification(id)))
      .subscribe((x) => setEdited(new PubmedEntry(x)));
  };

  return (
    <div
      data-tab={edited ? "none" : "classifications"}
      className="tw-pb-2 anim-fade-in anim-duration-400 font-helvetica"
    >
      <div className="tw-p-2 tw-pt-2 tw-px-2 tw-relative tw-bg-blueGray-200 tw-rounded-lg">
        {edited ? (
          <PubmedFormWidget
            userCanUpdateArticle={true}
            onCancel={() => setEdited(null)}
            entry={edited}
          />
        ) : (
          <ContributionEl article={article} contribution={contribution} />
        )}

        {canEdit && !edited ? (
          <div
            data-tab="none"
            className="tw-absolute tw-top-0 tw-right-0 tw-px-2 hover:tw-underline"
          >
            <Btn onSubmit={() => loadEntry(contribution.id)}>Edit</Btn>
          </div>
        ) : null}
      </div>

      {shouldShowThread ? (
        <Thread
          sourceEntity={sourceEntity}
          subType="classifications"
          subTypeId={contribution.id}
          slug={slug}
          shouldAutoExpand={false}
          shouldHideLines={false}
        />
      ) : null}
    </div>
  );
}

ContributionContainer.propTypes = {
  sourceEntity: PropTypes.instanceOf(SourceEntity),
  contribution: PropTypes.instanceOf(Contribution).isRequired,
  article: PropTypes.shape({ pub_med_id: PropTypes.number }),
  shouldShowThread: PropTypes.bool,
};

ContributionContainer.defaultProps = {
  sourceEntity: null,
  article: null,
  shouldShowThread: true,
};

export default React.memo(ContributionContainer);
